<template>
  <!-- Start Containerbar -->
  <div id="containerbar">
    <!-- Start Rightbar -->
    <div class="rightbar">
      <!-- Start Breadcrumbbar -->
      <div class="breadcrumbbar">
        <div class="row align-items-center">
          <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12">
            <h4 class="page-title">{{ $t("products.supplies") }}</h4>
            <div class="breadcrumb-list">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/dashboard">{{ $t("products.home") }}</a>
                </li>
                <li class="breadcrumb-item">
                  {{ $t("products.configuration") }}
                </li>
                <li class="breadcrumb-item">
                  <a href="#">{{ $t(title) }}</a>
                </li>
              </ol>
            </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xs-12 col-sm-12 content-button">
            <button
              class="btn btn-outline-success"
              v-if="
                showAction(1) && withPermissionName(permissions.CAT_PRO_ADD_01)
              "
              @click="changeAction(2)"
            >
              <i class="feather icon-plus mr-1"></i> {{ $t("global.create_products") }}
            </button>
            <button
              class="btn btn-outline-success"
              v-if="showAction(2) || showAction(3)"
              @click="changeAction(1),component=1"
            >
              <i class="feather icon-arrow-left mr-2"></i> {{ $t("global.return_to") }}
            </button>
          </div>
        </div>
      </div>
      <div class="contentbar">
        <div class="row">
          <div class="col-12">
            <div class="card">
              <AlertMessageComponent ref="alertMessageComponent" />
              <div class="card-header">
                <div class="row align-items-center">
                  <div class="col">
                    <h5 class="card-title mb-0">
                      <i class="feather icon-shopping-bag mr-2"></i
                      >{{ $t(titleAction) }}
                      
                    </h5>
                  </div>
                </div>
              </div>
              
           
              <div v-show="showAction(1)">
                <TableComponentProducts
                  ref="tableProd"
                  :headers="headers"
                  :isButton="true"
                  @excelTable="excelTable"
                  @updateRecord="edit"
                  :isUpdate="withPermissionName(permissions.CAT_PRO_EDIT_02)"
                > 
              </TableComponentProducts> 
              </div>
              
              <div v-if="showAction(2) || showAction(3) || showAction(4)">
                <div class="card">
                  <div class="card-body">
                    <validation-observer ref="observer" v-slot="{ invalid }">
                      <form @submit.prevent="doAction">
                        <div class="row">
                          <div class="col-md-12 pb-0">
                            <h6>
                              <v-icon class="pb-1"
                                >mdi-numeric-1-box-outline</v-icon
                              >
                              {{ $t("products.information_products") }}
                            </h6>
                          </div>
                          
                          <div class="col-md-4">
                            <validation-provider
                              v-slot="{ errors }"
                              name="typeProduct"
                              rules="required"
                            >
                            
                              <v-autocomplete
                                :items="typeProduct"
                                v-model="model.typeProduct"
                                :error-messages="errors"
                                :disabled="model.description !=='' || action==3"
                                :label="$t('label.typeProduct')"
                                @change="listAllBrand"
                              > 
                              </v-autocomplete>
                            </validation-provider>
                          </div> 
                          <div class="col-md-8">
                            <validation-provider
                              v-slot="{ errors }"
                              name="causes"
                              rules="required|max:50">

                              <!-- Se quito el disable para que puedan ingresar el identificadro que necesiten -->
                              <v-text-field
                                v-model="model.productKey"
                                :counter="50"
                                :error-messages="errors"
                                :label="'Cnis / Causes / Idenficador'"
                                required
                                autocomplete="off"
                              ></v-text-field>
                            </validation-provider>
                          </div>
                          <div class="col-md-4">
                            <validation-provider
                              v-slot="{ errors }"
                              name="unit_of_measure"
                            >
                              <v-autocomplete
                                :items="unitsMeasurement"
                                v-model="model.unitMeasurement"
                                :error-messages="errors"
                                :no-data-text="$t('label.no_results')"
                                :label="$t('label.unit_of_measure')"
                              >
                              </v-autocomplete>
                            </validation-provider>
                          </div>
                          <div class="col-md-5">
                            
                            <BrandComponent 
                              :component="component"
                              :nuevoObjeto="nuevoObjeto"
                              @update:newNameBrand="prueba"
                              ref="BrandComponent"
                            />
                          </div> 
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="description"
                              rules="required|max:2000"
                            >
                              <v-textarea
                                outlined
                                v-model="model.description"
                                name="description"
                                :label="$t('label.description')"
                                :error-messages="errors"
                                :disabled="model.typeProduct ==null"
                                required
                                :counter="2000"
                                :maxlength="2000"
                                rows="3"
                                row-height="20"
                              ></v-textarea>
                            </validation-provider>
                          </div>
                        </div>

                        <div class="col-md-12 text-right">
                          <button
                            class="btn btn-outline-success"
                            type="submit"
                            :disabled="invalid || sending"
                            
                          >
                            <i class="feather icon-save mr-1"></i>
                            {{ $t("global.save_products") }}
                          </button>
                        </div>
                      </form>
                    </validation-observer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import AlertMessageComponent from "@/common/message/AlertMessageComponent";
import TableComponentProducts from "@/common/table/TableComponentProducts";
import { PRODUCTS } from "@/core/DataTableHeadersLocale";
import BrandComponent from "../../common/select/BrandComponent.vue";
import { SwalConfirm } from "@/core/SwalAlert";

import { UtilFront, PermissionConstants } from "@/core";
import { ProductsRequest, CategoryRequest, ExcelRequest } from "@/core/request";
import { ValidationObserver, ValidationProvider } from "vee-validate";



export default {
  data() {
    return {
      title: "products.products",
      remmisionList: [],
      selected: [],
      list: [],
      headers: PRODUCTS(),
      search: "",
      SearchBrand: null,
      sending: false,
      dialog: false,
      filterlist: [],
      dialogBrand: false, // Modifique el nombre de la variable para volver el modal más especifico

      model: { 
        idProduct: "",
        productKey: "",
        name: "",
        description: "",
        unitMeasurement: 0,
        categories: [],
        //modelo: null,
        typeProduct: null,
        brand: null,
        nameBrand: "",
        newNameBrand: "",
        
      },
      index: 0,
      nuevoObjeto:[],
      categories: [],
      service: ProductsRequest,
      unitsMeasurement: [],
      typeProduct: [],
      action:1,
      component:1,
      brand: [],
      warning: false,
      newBrand: [],
      permissions: PermissionConstants,
      loading: null,
      newBrands:[]
    };
  },
  computed: {
    titleAction() {
      if (this.action == 1) {
        return "products.products";
      } else if (this.action == 2) {
        return "products.register_products";
      } else if (this.action == 3) {
        return "products.edit_products";
      }
      return "Listado";
    },
    
  },
  methods: {
    typeProdText() {
      const selectedtypeProduct = this.typeProduct.find(item => item.value === this.model.typeProduct);
      return selectedtypeProduct ? selectedtypeProduct.text : '';
    },
    unitdText() {
      const selectedunit = this.unitsMeasurement.find(item => item.value === this.model.unitMeasurement);
      return selectedunit ? selectedunit.text : '';
    },
    showAction(action) {
      return this.action == action;
    },
    closeDialog() {
        this.dialogBrand = false // Método para cerrar nueva marca
        this.model.newNameBrand = "";
      },
    async listAllBrand(){
      //console.log(this.unitsMeasurement);
      this.$refs.BrandComponent.listbrand();
      if (this.model.typeProduct==1){
        this.model.unitMeasurement="12"
      }
      if(this.model.typeProduct!=1){
        this.model.unitMeasurement=0
      }
    },
    async listTypeProduct(){
      
      await ProductsRequest.listAllTypeProducts()
        .then((res) => {
          let { data, success } = res.data.data;
          if (success) {
            this.typeProduct = data;
          } else {
            this.typeProduct = [];
            this.$refs.alertMessageComponent.reloadComponent(message);
          }
        })
        .catch((error) => {
          console.log(error);
          
          this.alert("internal");
        })
        .finally(() => {
          this.sending = false;
        });
      
    },
    async changeAction(action) {
      if (action == 1) {
        this.$refs.observer.reset();
          this.model = {
          idProduct: "",
          productKey: "",
          description: "",
          unitMeasurement: 0,
          categories: [],
          //modelo: null,
          typeProduct: null,
          brand: null,
          nameBrand: "",
          newNameBrand: "",
          SearchBrand: null,
        };
        this.action = action;
      } else {
        try {
          this.loading = UtilFront.getLoadding();
          //await this.listAllCategories();
          //await this.$refs.BrandComponent.listbrand(); POSIBLE ERROR
          await this.listTypeProduct();

          await this.listAllUnitMeasurement();
          this.action = action;
        } catch (error) {
          this.error(error);
        } finally {
          this.loading.hide();
        }
      }
    },
    doAction() {
      if (this.action == 2) {
        this.add();
      } else if (this.action == 3) {
        this.update();
      }
    },
    alert(type, message) {
      this.$refs.alertMessageComponent.reloadComponent(type, message);
    },
    async listAll() {
      //this.component=1
      //console.log(res);
      await ProductsRequest.listAll()
        .then( async (res) => {
          //console.log(res);
          let { data, success } = res.data.data;
          if (success) {
            await this.listTypeProduct();
            //await this.listbrand();
            this.$refs.tableProd.reloadComponent(data,this.typeProduct);
            //console.log(this.mainlist)
          }
        })
        .catch((error) => {
          
          console.log(error);
          this.alert("error", "Ocurrio un error interno.");
        })
        .finally(() => {});
    },
    namebrand() {
      let nameBrand = this.brand.filter((element) => {
        if (element.value == this.model.brand) return element;
      });
      return this.model.nameBrand=nameBrand[0].text;
    },
    async add() {
      //this.component=1
      const { isConfirmed } = await SwalConfirm.fire({
        title:
          "El producto con la siguiente información será registrado en el catálogo. ¿Estás seguro? ",
        html:
          "<div class='row'>" +
          "<div class='col-md-12 pb-0'><b>" +
          "Tipo de producto: </b>" +
            this.typeProdText()+
          "</div>" +
          "<div class='col-md-12 pb-0'><b>" +
          "Cause: " +
          "</b>" +
          this.model.productKey +
          "</div>" +
          "<div class='col-md-12  pb-0'><b>" +
          "Unidad de medida: " +
          "</b>" +
          this.unitdText() +
          "</div>" +
          "<div class='col-md-12  pb-0'><b>" +
          "Marca: " +
          "</b>" +
          this.$refs.BrandComponent.namebrand2() +
          "</div>" +
          "<div class='col-md-12'><b>" +
          "Descripción: " +
          "</b>" +
          this.model.description 
          
      });
      if (!isConfirmed) {
        return;
      }
      this.loading = UtilFront.getLoadding();
      this.sending = true;
      let product = {
        categories: this.model.categories,
        description: this.model.description,
        productKey: this.model.productKey.toUpperCase(),
        unitMeasurement: this.model.unitMeasurement,
        typeProduct: this.model.typeProduct, 
        productBrand:{
          idBrand: this.$refs.BrandComponent.returData(),
          nameBrand: this.$refs.BrandComponent.namebrand()
        },
        name:'',
        userBranchOfficeDTO: {
          idUser: UtilFront.getDataUser().idUser,
        },
      };
      ProductsRequest.add(product)
        .then((res) => {
          let { data } = res.data;
          let { message, success } = data;
          if (success == true) {
            this.alert("success", "Add_Success_0001");
          } else {
            this.alert("error", message);
          }
        })
        .catch((error) => this.error(error))
        .finally(() => {
          this.loading.hide();
          this.sending = false;
          this.listAll();
          this.changeAction(1);
          this.newBrands=[];
        });
    },
    prueba(value){  //cambiar name
      this.newBrands=value
      //console.log(this.newBrands);
    },
    async update() {
      console.log(this.model.nameBrand);
      this.loading = UtilFront.getLoadding();
      let productUpdate = {
        idProduct: this.model.idProduct,
        description: this.model.description,
        productKey: this.model.productKey.toUpperCase(),
        unitMeasurement: this.model.unitMeasurement,
        categories: this.model.categories,
        typeProduct: this.model.typeProduct,
        brands:this.newBrands,
        userBranchOfficeDTO: {
          idUser: UtilFront.getDataUser().idUser,
        },
      };
      console.log(productUpdate)
      this.sending = true;
      await ProductsRequest.update(productUpdate)
        .then((res) => {
          let { data } = res.data; 
          let { message, success } = data;
          if (success) {
            this.alert("success", "Update_Success_0001");
          } else {
            this.alert("error", "Error_product_0004");
          }
        })
        .catch((error) => {
          console.log(error);
          this.alert("internal");
        })
        .finally(() => {
          this.loading.hide();
          this.sending = false;
          this.listAll();
          this.changeAction(1);
          this.newBrands=[];
        });
    },

    edit(object) {
      this.component=3
      console.log(this.component)
      object.typeProduct= ''+object.typeProduct
      this.nuevoObjeto=object.brands
      this.model = {
        ...this.model,
        ...object,
      };
      console.log( object );
      this.model.unitMeasurement = object.unitMeasurement.toString();
      this.model.categories = this.model.categories.map((object) => {
        return {
          idCategory: object.idCategory,
        };
      });

      

      this.changeAction(3);
    },
    async listAllCategories() {
      await CategoryRequest.listAll()
        .then((res) => {
          let { data } = res.data;
          if (data.objects) {
            this.categories = data.objects.map((object) => {
              let fullName = object.name;
              if (
                object.name.trim().toLowerCase() !=
                object.description.trim().toLowerCase()
              ) {
                fullName += " " + object.description;
              }
              return {
                value: {
                  idCategory: object.idCategory,
                },
                text: fullName,
              };
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.alert("internal");
        })
        .finally(() => {
          this.sending = false;
        });
    },
    async listAllUnitMeasurement() {
      await ProductsRequest.listAllUnitMeasurement()
        .then((res) => {
          let { data, success } = res.data.data;
          if (success) {
            this.unitsMeasurement = data;
          } else {
            this.unitsMeasurement = [];
            this.$refs.alertMessageComponent.reloadComponent(message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.alert("internal");
        })
        .finally(() => {
          this.sending = false;
        });
    },
    withPermissionName(namePermission) {
      return UtilFront.withPermissionName(namePermission);
    },
    excelTable() {
      this.$toast.success("Generando documento Xlsx");
      ExcelRequest.reportProducts({});
    },
  },
  mounted() {

  },

  async created() {
    try {
      this.loading = UtilFront.getLoadding();
      await this.listAllUnitMeasurement();
      //await this.listAllCategories();
      await this.listAll();
      await this.listTypeProduct();
      this.loading.hide();
    } catch (error) {
      this.error(error);
    } finally {
      this.loading.hide();
    }
  },
  watch: {
    "$i18n.locale": function() {
      this.headers = PRODUCTS();
    },
  },
  components: {
    TableComponentProducts,
    ValidationProvider,
    ValidationObserver,
    AlertMessageComponent,
    BrandComponent
  },
};
</script>

<style>
.theme--light.v-messages {
  color: rgb(255 0 0);
}
</style>
